
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1620"}},[_c('path',{attrs:{"data-name":"Rectangle 2345","fill":"none","d":"M0 0h20v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1624"}},[_c('path',{attrs:{"data-name":"Path 990","d":"M17.999 6.5a1.007 1.007 0 01-.447-.105L10 2.618 2.447 6.395a1.001 1.001 0 01-.9-1.789l8-4a1 1 0 01.9 0l8 4a1 1 0 01-.448 1.894z","fill":"#adadad"}}),_c('path',{attrs:{"data-name":"Path 991","d":"M18 19.5H2a1 1 0 010-2h16a1 1 0 010 2z","fill":"#adadad"}}),_c('path',{attrs:{"data-name":"Path 992","d":"M16.5 16.5h-13a1 1 0 010-2h13a1 1 0 010 2z","fill":"#adadad"}}),_c('g',{attrs:{"data-name":"Group 1623"}},[_c('path',{attrs:{"data-name":"Path 993","d":"M5 13.5a1 1 0 01-1-1v-5a1 1 0 012 0v5a1 1 0 01-1 1z"}}),_c('path',{attrs:{"data-name":"Path 994","d":"M10 13.5a1 1 0 01-1-1v-5a1 1 0 012 0v5a1 1 0 01-1 1z"}}),_c('path',{attrs:{"data-name":"Path 995","d":"M15 13.5a1 1 0 01-1-1v-5a1 1 0 012 0v5a1 1 0 01-1 1z"}})])])])])
          )
        }
      }
    